    <div class="updates">
        <div class="updates_item" *ngFor="let update of updates">
            <div class="updates_title">{{update}}</div>
        </div>
    </div>
